/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PageHeaders() {

  useEffect(() => {
    const timestamp = new Date().getTime(); // unique per load

    // Select all possible icons
    const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
    const shortcutIcon = document.querySelector("link[rel='shortcut icon']");

    // Save original hrefs to restore on unmount
    const originalAppleHref = appleIcon?.getAttribute("href");
    const originalShortcutHref = shortcutIcon?.getAttribute("href");

    // Update icons with cache-busting
    if (appleIcon) appleIcon.setAttribute("href", `/saa-c03-icon.png?v=${timestamp}`);
    if (shortcutIcon) shortcutIcon.setAttribute("href", `/saa-c03-favicon.png?v=${timestamp}`);

    // Restore original icons on unmount
    return () => {
      if (appleIcon) appleIcon.setAttribute("href", originalAppleHref);
      if (shortcutIcon) shortcutIcon.setAttribute("href", originalShortcutHref);
    };
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    // Detect user's device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if iOS
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    // Check if Android
    const isAndroid = /android/i.test(userAgent);

    // Set destination URLs
    const url1 = "https://apps.apple.com/us/app/aws-solution-architect-saa/id6757360993";
    const url2 = "https://play.google.com/store/apps/details?id=com.techcoo.DoPaper.saac02";

    // Determine where to redirect based on device
    if (isIOS) {
      window.location.href = url1;
    } else if (isAndroid) {
      window.location.href = url2;
    } else {
      window.location.href = url1;
    }

  }, [navigate]);

  return (
    <></>
  );
}

export default PageHeaders;
